<template>
    <div class="apply-job-wrapper" title="Apply Now" code-toggler>
        <div class="mb-3">
          <h3 class="mb-5 title">Get Started</h3>
          <p class="description">Please enter the following information to get connected to this job.</p>
        </div>
        <div>
            <form action="" method="POST" ref="applyForm">
                <div class="vx-row w-full">
                    <div class="vx-col relative mb-4 lg:mb-2 w-1/2 mt-3 pr-2">
                        <label for="" class="block mb-1">First Name</label>
                        <vs-input v-validate="'required|alpha_spaces'" @change="validateProfanity($event, 'first_name')" name="first_name" v-model.trim="first_name" class="w-full h-42px" maxlength="40" />
                        <span class="text-danger text-10 absolute"  v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>
                    </div>

                    <div class="vx-col relative mb-4 lg:mb-2 w-1/2 mt-3 pl-2">
                        <label for="" class="block mb-1">Last Name</label>
                        <vs-input v-validate="'required|alpha_spaces'" @change="validateProfanity($event, 'last_name')" name="last_name" v-model.trim="last_name" class="w-full h-42px" maxlength="40" />
                        <span class="text-danger text-10 absolute"  v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>
                    </div>

                    <div class="vx-col relative mb-4 lg:mb-2 md:w-1/2 mt-3 w-full md:pr-2">
                        <label for="" class="block mb-1">Email</label>
                        <vs-input v-validate="'required|email'" name="email" @change="validateProfanity($event, 'email')" v-model="email" class="w-full h-42px" />
                        <span class="text-danger text-10 absolute"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
                    </div>

                    <div class="vx-col relative mb-4 lg:mb-2 w-1/2 md:w-1/4 mt-3 pr-2 md:pl-2">
                        <label for="" class="block mb-1">Mobile Phone</label>
                        <vs-input type="tel" v-validate="{ required: true, regex: /^(\(?[0-9]{1,3}\)?)(\s?[0-9]{0,3}-?[0-9]{0,4})$/ }" @input="setDirty('phone')" @keyup="formatPhoneNumber" @blur="validatePhoneNumberOnBlur" name="phone" v-model="phone" class="w-full h-42px" maxlength="14" />
                        <span class="text-danger text-10 absolute"  v-show="isErrorVisible('phone')">{{ getErrorMessage('phone') }}</span>
                    </div>

                    <div class="vx-col relative mb-4 lg:mb-2 w-1/2 md:w-1/4 mt-3 pl-2">
                        <label for="" class="block mb-1">Zip</label>
                        <vs-input type="text" v-validate="'required|digits:5'" name="zip_code" v-model="zip_code" class="w-full h-42px" maxlength="5" @input="setDirty('zip_code')"/>
                        <span class="text-danger text-10 absolute"  v-show="isErrorVisible('zip_code')">{{ getErrorMessage('zip_code') }}</span>
                    </div>

                </div>
                <div class="mt-4" v-for="(question, i) in questions" :key="i">
                    <label>{{ question['title'] }}</label>
                    <vs-input type="text" v-if="question['type'] === 'text'" v-validate="question['is_required'] && 'required'" :name="'question_'+question['id']" v-model="customFields['question_'+question['id']]" class="w-full" />
                    <vs-input type="number" v-else-if="question['type'] === 'number'" v-validate="question['is_required'] && 'required'" :name="'question_'+question['id']" v-model="customFields['question_'+question['id']]" class="w-full" />
                    <vs-textarea v-else-if="question['type'] === 'textarea'" v-validate="question['is_required'] && 'required'" :name="'question_'+question['id']" v-model="customFields['question_'+question['id']]" class="w-full" />
                    <div v-else-if="['single-select', 'dropdown'].includes(question['type'])">
                        <v-select v-validate="question['is_required'] && 'required'" :options="question['options']" :name="'question_'+question['id']" :value="customFields['question_'+question['id']]" @input="storeSingleSelect($event, 'question_'+question['id'])" class="w-full" searchable />
                        <!--Hack to support v-select as regular html form submission-->
                        <input type="hidden" :name="'question_'+question['id']" :value="customFields['question_'+question['id']]" />
                    </div>
                    <div v-else-if="question['type'] === 'multi-select'">
                        <v-select v-validate="question['is_required'] && 'required'" :multiple="true" :options="question['options']" :name="'question_'+question['id']" :value="multiSelects['question_'+question['id']]" @input="storeMultiSelect($event, 'question_'+question['id'])" class="w-full" />
                        <!--Hack to support v-select as regular html form submission-->
                        <input type="hidden" :name="'question_'+question['id']" :value="customFields['question_'+question['id']]" />
                    </div>
                    <ul class="centerx" v-else-if="question['type'] === 'radio-group'">
                        <li v-for="(option, i) in question['options']" :key="i">
                            <vs-radio v-model="customFields['question_'+question['id']]" v-validate="question['is_required'] && 'required'" :vs-value="option.code" :name="'question_'+question['id']">{{ option.label }}</vs-radio>
                        </li>
                    </ul>
                    <span class="text-danger text-10" v-show="isErrorVisible('question_'+question['id'])">{{ question['title'] }} is required.</span>
                </div>
                <div class="md:mt-10 flex flex-col-reverse md:flex-row md:align-items-center ">
                    <p class="tcpa mb-29" v-html="tcpa"></p>
                    <primary-button :disabled="loading" size="large" class="w-full md:w-auto text-lg md:text-base mt-6 mb-4 md:mt-0 md:mb-0 get-connected-btn only-mobile" @click="submitForm">
                      Get Connected <span class="ml-2" v-show="loading"><i class="fas fa-circle-notch fa-spin"></i></span>
                    </primary-button>
                    <primary-button :disabled="loading" class="w-full md:w-auto text-lg md:text-base mt-8 mb-8 md:mt-0 md:mb-0 get-connected-btn only-desktop" @click="submitForm">
                      Get Connected <span class="ml-2" v-show="loading"><i class="fas fa-circle-notch fa-spin"></i></span>
                    </primary-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
// For custom error message
import { Validator } from 'vee-validate';
import vSelect from 'vue-select'
import FormatPhoneNumberMixin from "../../mixins/FormatPhoneNumberMixin";
import HandleBackEndErrorsMixin from "../../mixins/HandleBackEndErrorsMixin";
import QueryBuilder from "../../utilities/querybuilder";

export default {
    mixins: [
        FormatPhoneNumberMixin,
        HandleBackEndErrorsMixin
    ],
    props : {
        applicant: {},
        tcpa : {
            type : String,
            default : ''
        },
        questions : {
            type : Array,
            default : () => { return [] }
        }
    },
    components: {
        'v-select': vSelect,
    },

  data () {
    return {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      zip_code: '',
      customFields : {},
      multiSelects : {},
      loading: false,
      profanityFilters: [],
    }
  },

    created(){
        this.fetchProfanityFilters();
        this.handleFillApplicantForm();
        let dict = {
            custom: {
                first_name: {
                    required: 'First Name is required',
                    alpha_spaces: 'Your First Name may only contain alphabetic characters'
                },
                last_name: {
                    required: 'Last Name is required',
                    alpha_spaces: 'Your Last Name may only contain alphabetic characters'
                },
                email: {
                    required: 'Email is required',
                    email: 'Enter a valid email address'
                },
                phone: {
                    required: 'Mobile Phone is required',
                    regex: 'The mobile phone field format is invalid'
                },
                zip_code: {
                    required: 'Zip is required',
                    digits: 'Enter a valid zip code'
                },
            }
        };

        this.questions.forEach( question => {
            this.customFields[question.name] = '';

            dict.custom[question.name] = { required : 'This field is required'};
        });

        // register custom messages
        Validator.localize('en', dict);
    },

  mounted() {
      const formData = JSON.parse(sessionStorage.getItem('applyFormData'));
      if (formData) {
        Object.keys(formData).forEach(key => {
            this[key] = formData[key];
        })
      }
  },
  computed: {
      formData() {
          const data = { ...this.$data };
          delete data.customFields;
          delete data.dirtyFields;
          delete data.multiSelects;

          return data;
      }
  },
  methods: {
    storeSingleSelect(event, question){
      this.customFields[question] = event.label;
    },
    storeMultiSelect(event, question){
      this.multiSelects[question] = event;
      let answers = '';
      event.forEach(answer => {
        if (!answers) {
          answers = answer.label;
        } else {
          answers += ' & '+ answer.label;
        }
      })
      this.customFields[question] = answers;
    },
    handleFillApplicantForm() {
      if (this.applicant.id) {
        this.first_name = this.applicant.first_name;
        this.last_name = this.applicant.last_name;
        this.email = this.applicant.email;
        this.phone = this.applicant.phone_formatted;
        this.zip_code = this.applicant.zip_code;
      }
    },

    async submitForm(e) {
      const result = await this.$validator.validateAll();
      const checkFirstNameProfanity = this.isFieldContainProfanity(this.first_name, 'first_name');
      const checkLastNameProfanity = this.isFieldContainProfanity(this.last_name, 'last_name');
      const checkEmailProfanity = this.isFieldContainProfanity(this.email, 'email');
      const isValidProfanity = checkFirstNameProfanity && checkLastNameProfanity && checkEmailProfanity;
      if (result && this.isPhoneNumberValid(this.phone) && isValidProfanity) {
        sessionStorage.setItem('applyFormData', JSON.stringify(this.formData));
        this.loading = true;
        this.$refs.applyForm.submit();
      }
    },

    formatPhoneNumber(ev) {
      this.phone = this.setFormatPhoneNumber(ev, this.phone);
    },
    isPhoneNumberValid(input) {
        var validatePhoneNumberRegex = /^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/;
        if (!(validatePhoneNumberRegex.test(input))) {
            this.errors.add({ field: 'phone', msg: 'The mobile phone field format is invalid' });
            return false;
        }
        return true;
    },
    validatePhoneNumberOnBlur(e) {
        this.isPhoneNumberValid(e.target.value);
    },
    isFieldContainProfanity(val, field) {
      if (field === 'email') {
        val = val.split("@").join(', ').split('.').join(', ').split(', ');
      } else {
        val = val.split(" ");
      }
      const profanity = this.profanityFilters;
      for (let i = 0; i < val.length; i++) {
        const checkExactText = profanity.includes(val[i].toLowerCase());
        if (checkExactText) {
          this.errors.add({field: field, msg: 'Please remove profanity'});
          return false;
        }
      }
      return true;
    },
    validateProfanity(e, field) {
      let val = e.target.value;
      this.isFieldContainProfanity(val, field);
    },
    fetchProfanityFilters() {
      axios.get('/profanity-filter',
          {headers: {Accept: 'application/json'}})
          .then(response => {
            this.profanityFilters = response.data
      });
    }
  }
}
</script>
